import {dateFromStr, formatDate} from "../../common/time/TimeCalculator";
import {PrecipitationChart} from "./PrecipitationChart";
import {TimeScaleEnum} from "../../common/enum/enum";
import * as $ from "jquery";

/**
 * A container for a SPI indicator chart
 * @extends PrecipitationChart
 * @hideconstructor
 */
class SPIChart extends PrecipitationChart {

    getClassName() {
        return "SPIChart";
    }

    _extractChartData() {
        const valsForProcessor = {};
        const values = this.dataFromService.features[0].properties.rain.values;
        if(!values)
            return valsForProcessor;
        const timeScale = this._getTimeScale().getCode();
        Object.keys(values).forEach(dateStr => {
            const value = values[dateStr] ? values[dateStr].spi : undefined;
            const date = dateFromStr(dateStr);
            valsForProcessor[formatDate(date)] = value[timeScale] ? value[timeScale] : null;
        })
        return valsForProcessor;
    }

    _setTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._updateChart();
    }

    _getTimeScale() {
        if (!this.timeScale)
            this.timeScale = TimeScaleEnum._3;
        return this.timeScale;
    }

    _addMainLegend() {
        if(!this.dataFromService.features[0].properties.rain.values)
            return;
        const body = $('.container .body', this.uiElement);
        const smallGraphic = this.layer.getChartLegend() ? this.layer.getChartLegend().getChartGraphic() : undefined;
        if (smallGraphic && smallGraphic.length > 0) {
            smallGraphic.click(() => this.layer.showInfo(this.infoModal)).css('cursor', 'pointer');
            $('.container .body .legend-container', this.uiElement).append(smallGraphic);
            body.addClass('has-legend');
        } else {
            body.removeClass('has-legend');
        }
    }
}

export {SPIChart}